export const actionTypes: any = {
  // get
  GET_GOLD_RATE_CATEGORY_START: 'GET_GOLD_RATE_CATEGORY_START',
  GET_GOLD_RATE_CATEGORY_SUCCESS: 'GET_GOLD_RATE_CATEGORY_SUCCESS',
  GET_GOLD_RATE_CATEGORY_FINISH: 'GET_GOLD_RATE_CATEGORY_FINISH',

  // get
  GET_GOLD_RATE_START: 'GET_GOLD_RATE_START',
  GET_GOLD_RATE_SUCCESS: 'GET_GOLD_RATE_SUCCESS',
  GET_GOLD_RATE_FINISH: 'GET_GOLD_RATE_FINISH',

  // create
  CREATE_GOLD_RATE_START: 'CREATE_GOLD_RATE_START',
  CREATE_GOLD_RATE_SUCCESS: 'CREATE_GOLD_RATE_SUCCESS',
  CREATE_GOLD_RATE_FINISH: 'CREATE_GOLD_RATE_FINISH',
  CREATE_GOLD_RATE_RESET: 'CREATE_GOLD_RATE_RESET',

  // update
  UPDATE_GOLD_RATE_START: 'UPDATE_GOLD_RATE_START',
  UPDATE_GOLD_RATE_SUCCESS: 'UPDATE_GOLD_RATE_SUCCESS',
  UPDATE_GOLD_RATE_FINISH: 'UPDATE_GOLD_RATE_FINISH',
  UPDATE_GOLD_RATE_RESET: 'UPDATE_GOLD_RATE_RESET',

  //Activate deactivate
  ACTIVATE_GOLD_RATE_REQUEST: 'ACTIVATE_GOLD_RATE_REQUEST',
  ACTIVATE_GOLD_RATE_SUCCESS: 'ACTIVATE_GOLD_RATE_SUCCESS',
  ACTIVATE_GOLD_RATE_FINISH: 'ACTIVATE_GOLD_RATE_FINISH',

  SINGLE_ACTIVATE_GOLD_RATE_REQUEST: 'SINGLE_ACTIVATE_GOLD_RATE_REQUEST',
  SINGLE_ACTIVATE_GOLD_RATE_SUCCESS: 'SINGLE_ACTIVATE_GOLD_RATE_SUCCESS',
  SINGLE_ACTIVATE_GOLD_RATE_FINISH: 'SINGLE_ACTIVATE_GOLD_RATE_FINISH',

  SINGLE_DEACTIVATE_GOLD_RATE_REQUEST: 'SINGLE_DEACTIVATE_GOLD_RATE_REQUEST',
  SINGLE_DEACTIVATE_GOLD_RATE_SUCCESS: 'SINGLE_DEACTIVATE_GOLD_RATE_SUCCESS',
  SINGLE_DEACTIVATE_GOLD_RATE_FINISH: 'SINGLE_DEACTIVATE_GOLD_RATE_FINISH',

  DEACTIVATE_GOLD_RATE_REQUEST: 'DEACTIVATE_GOLD_RATE_REQUEST',
  DEACTIVATE_GOLD_RATE_SUCCESS: 'DEACTIVATE_GOLD_RATE_SUCCESS',
  DEACTIVATE_GOLD_RATE_FINISH: 'DEACTIVATE_GOLD_RATE_FINISH',

  // delete
  DELETE_GOLD_RATE_START: 'DELETE_GOLD_RATE_START',
  DELETE_GOLD_RATE_SUCCESS: 'DELETE_GOLD_RATE_SUCCESS',
  DELETE_GOLD_RATE_FINISH: 'DELETE_GOLD_RATE_FINISH',

  // get File csv xlsx
  GET_GOLD_RATE_FILE_START: 'GET_GOLD_RATE_FILE_START',
  GET_GOLD_RATE_FILE_SUCCESS: 'GET_GOLD_RATE_FILE_SUCCESS',
  GET_GOLD_RATE_FILE_FINISH: 'GET_GOLD_RATE_FILE_FINISH',

  // Import Gold rate
  IMPORT_GOLD_RATE_START: 'IMPORT_GOLD_RATE_START',
  IMPORT_GOLD_RATE_SUCCESS: 'IMPORT_GOLD_RATE_SUCCESS',
  IMPORT_GOLD_RATE_FINISH: 'IMPORT_GOLD_RATE_FINISH',
}
